import React from 'react';
import drPereiraImage from '../../images/team/dr-eugene-pereira.jpg';
import './WhyChooseUs.css';

const WhyChooseUs = () => {


    const credentials = [
        { icon: 'fas fa-graduation-cap', text: 'MD from St. John\'s Medical College (1991)' },
        { icon: 'fas fa-stethoscope', text: 'Anesthesiology Residency & ABMS Pain Management Fellowship at West Virginia University' },
        { icon: 'fas fa-certificate', text: 'Board-Certified Pain Management (ABA-PM)' },
        { icon: 'fas fa-award', text: 'Fellow of Interventional Pain Practice (FIPP) & Diplomate ABIPP' },
        { icon: 'fas fa-id-card', text: 'Licensed in FL, NY, NJ, UT' },
        { icon: 'fas fa-user-md', text: '1000+ Regenerative Procedures' }
    ];

    return (
        <section className="why-choose-us section-padding">
            <div className="container">
                <div className="why-content">
                    <div className="doctor-profile modern-layout">
                        <div className="doctor-image-container">
                            <div className="image-wrapper">
                                <img src={drPereiraImage} alt="Dr. Eugene G. Pereira, MD" />
                                <div className="gradient-overlay"></div>
                            </div>
                            <div className="doctor-quick-info">
                                <h3>Dr. Eugene G. Pereira, MD</h3>
                                <p>Medical Director & Founder</p>
                                <div className="specialties">
                                    <span className="specialty-tag">Pain Management Specialist</span>
                                    <span className="specialty-tag">Stem Cell Therapy Expert</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="doctor-details">
                            <div className="bio-section">
                                <h4>Meet Florida's Leading Regenerative Medicine Pioneer</h4>
                                <p>
                                    Dr. Pereira has revolutionized pain management in Florida by pioneering advanced 
                                    regenerative therapies that were previously only available internationally. With over 
                                    25+ years of expertise and 1000+ successful procedures, he brings world-class stem cell 
                                    treatments directly to patients across Florida through our concierge medical model.
                                </p>
                            </div>
                            
                            <div className="credentials-grid">
                                <div className="credentials-list">
                                    {credentials.map((credential, index) => (
                                        <div key={index} className="credential-item">
                                            <i className={credential.icon}></i>
                                            <span>{credential.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="cta-section">
                                <a href="/contact" className="consultation-btn">
                                    <i className="fas fa-calendar-check"></i>
                                    Schedule Your Consultation
                                </a>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;